module.exports = __webpack_public_path__ + "static/media/star.f27f51c1.svg";